import {
    Component,
    Input,
    Renderer2,
    ViewChild,
    ElementRef
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
    selector: 'ok-checkbox',
    template: `
        <!-- moved the click event into the div for the container. I spot checked a few spots but please let me know if this has any adverse reactions -->
        <div class="checkbox" (click)="onClick($event)" piTesting="ok-checkbox">
            <label>
                <input
                    style="height: 18px;"
                    type="checkbox"
                    [attr.id]="id"
                    [name]="id"
                    [checked]="_isChecked"
                    [disabled]="disabled"
                    #checkboxRef
                />
                <span [innerHTML]="label"></span>
            </label>
        </div>
    `,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: OkCheckboxComponent,
            multi: true
        }
    ],
    standalone: false
})
export class OkCheckboxComponent implements ControlValueAccessor {
    _isChecked: boolean;
    @Input()
    id = '';
    @Input()
    disabled = false;
    @Input()
    label = '';
    @ViewChild('checkboxRef', { static: true })
    checkboxRef: ElementRef;

    private propagateChange = (_: any) => {
        /* No-op required by ControlValueAccessor interface - see registerOnChange */
    };

    constructor(private _renderer: Renderer2) {}

    get value(): boolean {
        return this._isChecked;
    }

    set value(checked: boolean) {
        if (checked !== this._isChecked) {
            this._isChecked = checked;
            this.propagateChange(checked);
        }
    }

    onClick(event: Event): void {
        event.stopPropagation();
        event.preventDefault();
        if (!this.disabled) {
            this.value = !this.value;
        }
    }

    // ControlValueAccessor
    writeValue(value: boolean): void {
        this._isChecked = value;
        this._renderer.setProperty(
            this.checkboxRef.nativeElement,
            'checked',
            value
        );
    }
    registerOnChange(fn: any): void {
        this.propagateChange = (changed) => fn.call(this, changed);
    }
    registerOnTouched(): void {
        /* No callback function registered OnTouched */
    }

    setDisabledState(isDisabled: boolean) {
        this.disabled = isDisabled;
    }
}
